module.exports = __webpack_public_path__ + "img/1.8.TSS.a9e3711a.png";